// extracted by mini-css-extract-plugin
export default {"tab-navigation":"Tab_tab-navigation__Z+wqC","nav-item":"Tab_nav-item__YOtId","nav-link":"Tab_nav-link__umAzo","tab-pane":"Tab_tab-pane__GZ+Yb"};